export var setFocusOnElement = function (input, delayInMilliseconds) {
    setTimeout(function () {
        input === null || input === void 0 ? void 0 : input.focus();
        input === null || input === void 0 ? void 0 : input.click();
    }, delayInMilliseconds);
};
